import React from 'react'

/**
 * Deep Dive submarine glyph (no lucide/react-icons set ships one). Drawn in the
 * same 24px stroke style as the lucide icons around it: capsule hull, periscope,
 * three portholes. Used in the Agent chip, the settings triggers, and the
 * Deep Dive toggle row whenever effort level 6 is active.
 */
const SubmarineIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 10V5h3" />
    <rect x="2.5" y="10" width="19" height="8.5" rx="4.25" />
    <circle cx="7.5" cy="14.25" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="12" cy="14.25" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="16.5" cy="14.25" r="1.1" fill="currentColor" stroke="none" />
  </svg>
)

export default SubmarineIcon
